import React from 'react';
import { createRoot } from 'react-dom/client';
import 'maplibre-gl/dist/maplibre-gl.css';
import Kart from '../pages/kart/Kart.jsx';

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('kart-app');
    if (!container) return;

    const root = createRoot(container);
    root.render(<Kart />);
});
